import * as React from "react"
import {
    Tabs,
    Tab,
    Box,
    Typography,
    Stack,
    IconButton,
    Menu,
    MenuItem
} from "@mui/material"
import MenuIcon from "@mui/icons-material/Menu"
import DynamicTable from "../../pages/VR3_Form_Rendering/DynamicTable"
import DynamicForm from "../../pages/VR3_Form_Rendering/DynamicForm"
import { useDispatch, useSelector } from "react-redux"
import { setActiveTab } from "../../redux/DynamicForms/dynamicFormsActions"

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ py: 2 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

export function DynamicTabsComponent({
    titles,
    DynamicJson,
    isBodySection,
    id,
    onOpenChange,
    screenName
}) {
    const dispatch = useDispatch()
    const activeTabs = useSelector(state => state.dynamicForms.activeTabs || {})
    const activeTabVal = id ? activeTabs[id] : Object.values(activeTabs)[0] || undefined;
    const [active, setActive] = React.useState(id ? (activeTabs[id] ?? 0) : 0)

    const [anchorEl, setAnchorEl] = React.useState(null);
    const openMenu = Boolean(anchorEl);
    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };
    const handleMenuItemClick = (index) => {
        handleChange(null, index);
        setAnchorEl(null);
    };

    // Sync Redux -> Local
    React.useEffect(() => {
        if (id && activeTabVal !== undefined) {
            setActive(activeTabVal);
        }
    }, [activeTabVal, id]);

    const handleChange = (event, newValue) => {
        setActive(newValue);
        if (id) {
            dispatch(setActiveTab(id, newValue));
        }
    };

    if (isBodySection) {
        return (
            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider', position: 'sticky', top: 0, zIndex: 20, bgcolor: 'background.paper', display: 'flex', alignItems: 'center' }}>
                    <IconButton onClick={handleMenuClick} sx={{ ml: 1, mr: 1 }} aria-label="tabs-menu">
                        <MenuIcon />
                    </IconButton>
                    <Menu
                        anchorEl={anchorEl}
                        open={openMenu}
                        onClose={handleMenuClose}
                    >
                        {titles.map((item, i) => (
                            <MenuItem
                                key={i}
                                selected={i === active}
                                onClick={() => handleMenuItemClick(i)}
                            >
                                {item.title}
                            </MenuItem>
                        ))}
                    </Menu>
                    <Tabs
                        value={active}
                        onChange={handleChange}
                        aria-label="dynamic tabs"
                        variant="scrollable"
                        scrollButtons="auto"
                        sx={{
                            '& .MuiTab-root': {
                                textTransform: 'none',
                                fontWeight: 500,
                                minHeight: 48
                            }
                        }}
                    >
                        {titles.map((item, i) => (
                            <Tab key={i} label={item.title} />
                        ))}
                    </Tabs>
                </Box>

                {DynamicJson.map((subItem, stepIndex) => (
                    <TabPanel key={stepIndex} value={active} index={stepIndex}>
                        <Box sx={{ width: '100%' }}>
                            {subItem.children?.map((child, childIndex) =>
                                child.view === "form" ? (
                                    <DynamicForm
                                        key={`form-${stepIndex}-${childIndex}`}
                                        tree={subItem}
                                        rerender={() => { }}
                                        screenName={screenName || ""}
                                        onOpenChange={onOpenChange}
                                    />
                                ) : child.view === "table" ? (
                                    <DynamicTable
                                        key={`table-${stepIndex}-${childIndex}`}
                                        tableData={child}
                                        isBodySection={isBodySection}
                                        rerender={() => { }}
                                        screenName={screenName || ""}
                                        DocumentStatus=""
                                        showDrawer={() => { }}
                                        onOpenChange={onOpenChange}
                                    />
                                ) : null
                            )}
                        </Box>
                    </TabPanel>
                ))}
            </Box>
        )
    }

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', position: 'sticky', top: 0, zIndex: 20, bgcolor: 'background.paper', display: 'flex', alignItems: 'center' }}>
                <Tabs
                    value={active}
                    onChange={handleChange}
                    aria-label="dynamic tabs"
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{
                        '& .MuiTab-root': {
                            textTransform: 'none',
                            fontWeight: 500,
                            minHeight: 48
                        }
                    }}
                >
                    {titles.map((item, i) => (
                        <Tab key={i} label={item.title} />
                    ))}
                </Tabs>
            </Box>
            {Object.values(DynamicJson).map((items, stepIndex) => (
                <Stack spacing={4} sx={{ width: '100%' }} key={stepIndex}>
                    {items.map((subItem, idx) => (
                        <Box key={idx}>
                            {subItem.children?.map((child, childIndex) =>
                                child.view === "form" ? (
                                    <DynamicForm
                                        key={`form-${stepIndex}-${idx}-${childIndex}`}
                                        tree={subItem}
                                        rerender={() => { }}
                                        screenName=''
                                    />
                                ) : child.view === "table" ? (
                                    <DynamicTable
                                        key={`table-${stepIndex}-${idx}-${childIndex}`}
                                        tableData={child}
                                        isBodySection={!!isBodySection}
                                        rerender={() => { }}
                                        screenName=""
                                        DocumentStatus=""
                                        showDrawer={() => { }}
                                    />
                                ) : null
                            )}
                        </Box>
                    ))}
                </Stack>
            ))}
        </Box>
    )
}
